import { Grid } from "@material-ui/core"
import React, { memo, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import Form from "app/components/Form"
import Button from "components/Button"
import Select from "components/Select/Select"
import Translation from "components/Translation/Translation"
import * as practiceSelectors from "app/redux/practice/practice.selectors"
import * as practicesSelectors from "app/redux/practices/practices.selectors"
import { getPractices } from "app/redux/practices/practices.actions"
import { authorize } from "app/redux/authorization/authorization.actions"
import { StyledGridStretched } from "./style"
import { ISupportSettingsPracticeData } from "./types"

function SupportSettingsPracticeSwitch() {
  const dispatch = useDispatch()
  const practice = useSelector(practiceSelectors.getPractice)
  const practices = useSelector(practicesSelectors.getSelectingPreparedPractices)

  useEffect(() => {
    dispatch(getPractices())
  }, [dispatch])

  if (!practice) return null

  const defaultData: ISupportSettingsPracticeData = {
    practice: practice.id,
  }

  const handlePracticeSubmit = ({ practice }: ISupportSettingsPracticeData) => {
    dispatch(authorize(practice))
  }

  return (
    <Form defaultValues={defaultData} onSubmit={handlePracticeSubmit} cySelector="supportSettingsModalPracticeForm">
      <Grid container={true} alignItems="flex-end" justifyContent="space-between" spacing={2}>
        <StyledGridStretched item={true} alignItems="center">
          <Select name="practice" label="support.practice.label" options={practices} />
        </StyledGridStretched>
        <Grid item={true}>
          <Button type="submit" variant="contained" color="secondary">
            <Translation label="support.practice.button" />
          </Button>
        </Grid>
      </Grid>
    </Form>
  )
}

export default memo(SupportSettingsPracticeSwitch)
